module.exports = __webpack_public_path__ + "static/profile-unfolding-e8719f9a1200d625792d8bc461dd5af2.png";